"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _Selectable = _interopRequireDefault(require("../Selectable"));

var _Box = _interopRequireDefault(require("../Box"));

var _index = require("../index");

var __jsx = _react["default"].createElement;
var defaults = {
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      width: 20,
      height: 20,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
  }
};

function Checkmark() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __jsx(_Selectable["default"], props, function (state) {
    var sx = props.sx;

    if (typeof sx === "function") {
      sx = sx(state);
    }

    var _splitSx = (0, _index.splitSx)(sx),
        _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
        css = _splitSx2[0],
        customSx = _splitSx2[1];

    var iconStyles = customSx.$icon || {};

    if (typeof iconStyles === "function") {
      iconStyles = iconStyles(state);
    }

    return __jsx(_Box["default"], {
      sx: [defaults.$root(state), css]
    }, __jsx(_Box["default"], {
      as: "svg",
      viewBox: "0 0 14 14",
      focusable: "false",
      role: "presentation",
      sx: (0, _objectSpread2["default"])({
        display: "block",
        width: 12,
        height: 12
      }, iconStyles)
    }, __jsx("g", {
      fill: "currentColor"
    }, __jsx("polygon", {
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    }))));
  });
}

var _default = Checkmark;
exports["default"] = _default;